import React from 'react';
import { statusMeta } from '../monitoringUtils';

// Small pill showing Optimal / Caution / Critical.
export default function StatusBadge({ status, className = '' }) {
  const meta = statusMeta(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold ${meta.badgeBg} ${meta.text} ${className}`}
    >
      <span className={`w-2 h-2 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
}
